<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9354_80826)">
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint0_linear_9354_80826)"
      />
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint1_radial_9354_80826)"
      />
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint2_radial_9354_80826)"
      />
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint3_linear_9354_80826)"
      />
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint4_linear_9354_80826)"
      />
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint5_linear_9354_80826)"
      />
      <rect x="2"
            y="2"
            width="28"
            height="28"
            rx="3.6"
            fill="url(#paint6_linear_9354_80826)"
      />
      <path d="M14.7432 11.632C14.9965 11.1066 15.5315 10.75 16.1463 10.75C17.0055 10.75 17.702 11.4465 17.702 12.3057C17.702 12.9404 17.3208 13.4895 16.7728 13.7307C16.7633 13.7349 16.7531 13.7375 16.7427 13.7385C16.0243 13.8121 15.3978 14.3292 15.2195 15.0712C14.9943 16.0089 15.5701 16.9516 16.5062 17.18C16.5346 17.1884 16.5633 17.196 16.5922 17.2029C17.2348 17.3944 17.702 17.9917 17.702 18.6943C17.702 19.5535 17.0055 20.25 16.1463 20.25C15.4544 20.25 14.8637 19.7971 14.6632 19.1671C14.3701 18.2461 13.386 17.737 12.465 18.0301C11.544 18.3232 11.0349 19.3073 11.328 20.2283C11.9772 22.2686 13.8864 23.75 16.1463 23.75C18.9385 23.75 21.202 21.4865 21.202 18.6943C21.202 17.5113 20.7961 16.4242 20.1163 15.5637C20.0868 15.5264 20.0868 15.4737 20.1163 15.4364C20.7961 14.5758 21.202 13.4888 21.202 12.3057C21.202 9.51352 18.9385 7.25 16.1463 7.25C14.1371 7.25 12.405 8.42222 11.5904 10.1123C11.1707 10.9829 11.5363 12.0289 12.4069 12.4486C13.2775 12.8682 14.3235 12.5026 14.7432 11.632Z"
            fill="#FCF2FF"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear_9354_80826"
                      x1="16"
                      y1="2"
                      x2="16"
                      y2="30"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5BB3FD" />
        <stop offset="1"
              stop-color="#5194EC"
        />
      </linearGradient>
      <radialGradient id="paint1_radial_9354_80826"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(28.5 3.5) rotate(135) scale(3.53553 4.12942)"
      >
        <stop stop-color="#7AD3FE"
              stop-opacity="0.7"
        />
        <stop offset="1"
              stop-color="#7AD3FE"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint2_radial_9354_80826"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(3 29) rotate(-40.6013) scale(4.60977 5.3841)"
      >
        <stop stop-color="#3F70D6"
              stop-opacity="0.7"
        />
        <stop offset="1"
              stop-color="#3F70D6"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint3_linear_9354_80826"
                      x1="30"
                      y1="16"
                      x2="25.5"
                      y2="16"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#7AD3FE"
              stop-opacity="0"
        />
        <stop offset="0.479167"
              stop-color="#7AD3FE"
              stop-opacity="0.1"
        />
        <stop offset="1"
              stop-color="#7AD3FE"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint4_linear_9354_80826"
                      x1="16"
                      y1="2"
                      x2="16"
                      y2="6"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#7AD3FE"
              stop-opacity="0"
        />
        <stop offset="0.479167"
              stop-color="#7AD3FE"
              stop-opacity="0.13"
        />
        <stop offset="1"
              stop-color="#7AD3FE"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint5_linear_9354_80826"
                      x1="16"
                      y1="2"
                      x2="16"
                      y2="30"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#3F70D6"
              stop-opacity="0.35"
        />
        <stop offset="0.058296"
              stop-color="#3F70D6"
              stop-opacity="0"
        />
        <stop offset="0.872197"
              stop-color="#3F70D6"
              stop-opacity="0"
        />
        <stop offset="0.939462"
              stop-color="#3F70D6"
              stop-opacity="0.438597"
        />
        <stop offset="1"
              stop-color="#3F70D6"
        />
      </linearGradient>
      <linearGradient id="paint6_linear_9354_80826"
                      x1="29.9012"
                      y1="15.7489"
                      x2="2.27791"
                      y2="15.7489"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#3F70D6"
              stop-opacity="0.35"
        />
        <stop offset="0.058296"
              stop-color="#3F70D6"
              stop-opacity="0"
        />
        <stop offset="0.872197"
              stop-color="#3F70D6"
              stop-opacity="0"
        />
        <stop offset="0.939462"
              stop-color="#3F70D6"
              stop-opacity="0.438597"
        />
        <stop offset="1"
              stop-color="#3F70D6"
        />
      </linearGradient>
      <clipPath id="clip0_9354_80826">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>